<template>
  <component
    :is="icon ? 'IconButton' : 'BaseButton'"
    :size="size"
    :variant="variant"
    :icon="icon"
    @click.native="sendWidgetVerificationEmail"
    :disabled="hasSentVerificationEmail"
    data-ec="envelope_status"
    data-et="resend_button"
  >
    <span>{{ $t('envelope.widgetReminder.resendWidgetEmail') }}</span>
  </component>
</template>

<script>
import IconButton from '@/components/library/buttons/IconButton.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'VSendWidgetEmail',
  components: {
    BaseButton,
    IconButton,
  },
  props: {
    envelope: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      hasSentVerificationEmail: false,
    };
  },
  methods: {
    sendWidgetVerificationEmail(event) {
      event.stopPropagation();
      this.$store.dispatch('envelopes/SEND_WIDGET_VERIFICATION_EMAIL', this.envelope).then(() => {
        this.hasSentVerificationEmail = true;
      });
    },
  },
};
</script>
